import { ReactComponent as TimeSvg } from '../../assets/icons/time.svg';

export const TimeIcon: SvgIcon = (props) => {
    return <TimeSvg {...props} />;
};
